export default {"src":"/_next/static/media/icon-in-session.3d79a2fb.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};